import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    Renderer
} from '@angular/core';
import { IError } from '../model/types';
@Directive({ selector: '[error]' })
export class ErrorDirective implements OnChanges {

    @Input() public error: string;
    @Input() public errors: IError[];
    private element : HTMLElement;
    private isMessage : boolean;

    constructor(private el: ElementRef, private renderer: Renderer) {
        this.element = el.nativeElement;
        this.isMessage = this.element.tagName === 'DIV';
    }

    public ngOnChanges(changes) {
        if (this.isMessage) {
            this.element.innerHTML = '';
        } else {
            this.renderer.setElementClass(this.element, 'error', false);
        }

        if (!changes.errors || !changes.errors.currentValue) {
            return;
        }

        for (let error of changes.errors.currentValue.errors) {
            if (error.propertyPath === this.error) {
                if (this.isMessage) {
                    this.element.innerHTML = error.message;
                } else {
                    this.renderer.setElementClass(this.element, 'error', true);
                }
                return;
            }
        }
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/directive/error.directive.ts